<script>
    import { createEventDispatcher } from 'svelte'
    import { get } from 'dot-prop'
    import { FormGroup, Input, Label } from 'sveltestrap'
    import Required from './Required.svelte'
    import ValidationMessage from './ValidationMessage.svelte'

    export let context
    export let formKey
    export let index
    export let keypath // The keypath without the formKey or index, e.g. "attributes.videos.3.url"
    export let label
    export let required
    export let helptext
    export let value

    $: formKeypath = index === undefined ? `${formKey}.${keypath}` : `${formKey}.${index}.${keypath}`
    $: isInvalid = get(context, `error.${formKeypath}.level`) === 'error'
    $: stringValue = (value && new Date(value * 1000).toISOString().substr(0, 10)) || ''

    const dispatch = createEventDispatcher()
    const update = (event) => {
        value = event.target.value && new Date(event.target.value).getTime() / 1000
        dispatch('change', { formKey, index, keypath, value, context })
    }
</script>

<FormGroup>
    <Label for={formKeypath}>
        {label || ''}
        <Required {required} />
    </Label>
    <Input type="date" id={formKeypath} name={formKeypath} {isInvalid} value={stringValue} on:change={update} on:blur />
    <ValidationMessage {context} {formKeypath} {helptext} />
</FormGroup>
